import styled from 'styled-components';
import addAlpha from 'utils/addAlpha';
import { Body, Small } from 'components/Typography';
import DefaultAvatar from 'components/Avatar';
import DefaultActionButton from 'components/Buttons/ActionButton';

export const Content = styled.div`
  padding: 0 1.5rem 0 1.5rem;
  height: 100%;
  border-radius: 1rem;
`;

export const Container = styled.div`
  height: 5.5rem;
  padding: 0.25rem 0.5rem 0.25rem 0.5rem;

  > *:nth-child(5) {
    justify-self: flex-end;
  }

  ${Content} {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 10rem 6.5rem;
    align-items: center;
  }

  :hover {
    cursor: pointer;

    ${Content} {
      background-color: ${({ theme }) => theme.colors.gray1};
    }
  }
`;

export const MainText = styled(Body)`
  color: ${({ theme }) => theme.colors.navyGreen};
  font-weight: 600;
`;

export const Text = styled(Body)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
`;

export const Date = styled(Text)`
  font-variant-numeric: tabular-nums;
`;

export const SecondaryText = styled(Small)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
`;

export const Avatar = styled(DefaultAvatar)`
  margin-right: 1rem;
`;

export const Wrap = styled.div`
  display: flex;
  align-items: center;
`;

export const Button = styled.div`
  background-color: ${({ theme }) => theme.colors.yellowLight};
  color: ${({ theme }) => theme.colors.yellowDark};
  width: 7.5rem;
  height: 3rem;
  right: 11rem;
  border-radius: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ActionButton = styled(DefaultActionButton)`
  margin-left: 2rem;
`;
